import * as PropTypes from "prop-types";
import styled from "styled-components";

export default function Header({
  children,
  center,
  enableLargePadding,
  disableMargin,
  dataCy,
}) {
  return (
    <Header2
      data-cy={dataCy}
      enableLargePadding={enableLargePadding}
      center={center}
      disableMargin={disableMargin}
    >
      {children}
    </Header2>
  );
}

const Header2 = styled.div`
  ${padding};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.large};
  ${({ disableMargin }) => !disableMargin && `margin-bottom: 1.5rem`};
  ${({ center }) => center && "text-align: center;"};
`;

function padding({ enableLargePadding }) {
  if (enableLargePadding) {
    return "padding-left: 65px;padding-right: 65px;";
  }
  return "";
}

Header.defaultProps = {
  center: true,
};

Header.propTypes = {
  children: PropTypes.any,
  center: PropTypes.bool,
  enableLargePadding: PropTypes.bool,
  disableMargin: PropTypes.bool,
  dataCy: PropTypes.string,
};
